"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _s3upload = _interopRequireDefault(require("react-s3-uploader/s3upload"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /* eslint-disable @typescript-eslint/no-empty-function */ /**
 * SMPackages S3Uploader Module
 * @module @sm/utils
 */
var DEFAULT_OPTIONS = {
  preprocess: function preprocess(file, next) {
    next(file);
  },
  onSignedUrl: function onSignedUrl() {},
  onProgress: function onProgress() {},
  onFinish: function onFinish() {},
  onError: function onError() {},
  signingUrl: '/core/api/s3/sign',
  scrubFilename: function scrubFilename(filename) {
    return ".".concat(filename.split('.').pop());
  },
  s3path: '',
  autoUpload: true
};
/**
 * Creates a new S3Uploader.
 * @class
 */
var S3Uploader = exports.default = /*#__PURE__*/function () {
  function S3Uploader(options) {
    _classCallCheck(this, S3Uploader);
    /**
     * @constructs S3Uploader
     * @param {Object} options S3Uploader options
     * @param {string} options.server S3Uploader server
     * @param {string} options.signingUrl S3Uploader singingUrl
     * @param {string} options.server S3Uploader server
     * @param {Array} options.successResponses {code, code} Success responses
     * @param {string} [options.signingUrlMethod="GET"] S3Uploader singingUrlMethod
     * @param {string} [options.s3path=""] S3Uploader s3path
     * @param {boolean} [options.autoUpload=true] S3Uploader autoupload
     * @param {Object} options.files S3Uploader files
     * @param {Object} options.fileElement S3Uploader fileElement
     * @param {Function} options.onFinishS3Put S3Uploader onFinishS3Put function
     * @param {Function} options.onFinish OnFinish uploading function
     * @param {Function} options.preprocess preprocess function
     * @param {Function} options.onProgress onProgress uploading function
     * @param {Function} options.onError on upload error function
     * @param {Function} options.onSignedUrl signed url function
     * @param {Function} options.fileElement fileElement
     * @param {Function} options.inputRef inputRef
     * @param {Function} options.contentDisposition
     * @param {Object} options.uploadRequestHeaders
     * @param {boolean} options.getSignedUrl
     */
    this.options = void 0;
    this.myUploader = void 0;
    this.options = _objectSpread(_objectSpread({}, DEFAULT_OPTIONS), options);
  }

  /**
   * Upload the file
   */
  return _createClass(S3Uploader, [{
    key: "uploadFile",
    value: function uploadFile() {
      this.myUploader = new _s3upload.default(_objectSpread(_objectSpread({}, DEFAULT_OPTIONS), this.options));
    }

    /**
     * Abort the upload
     */
  }, {
    key: "abort",
    value: function abort() {
      if (this.myUploader) {
        this.myUploader.abortUpload();
      }
    }
  }]);
}();
module.exports = exports.default;
//# sourceMappingURL=S3Uploader.js.map